import * as types from './types';
import customAxios from './axios';
import CONFIG from '../../config';
import axios from 'axios';

export const formMetaData = (data) => ({
    type: types.FORM_META_DATA,
    data
});

export const addFieldData = (data) => ({
    type: types.ADD_FIELD_DATA,
    data
});

export const editFieldData = (id, data) => ({
    type: types.EDIT_FIELD_DATA,
    id,
    data
});

export const deleteFieldData = (data) => ({
    type: types.DELETE_FIELD_DATA,
    data
});

export const reArrangeFieldData = (data) => ({
    type: types.REARRANGE_FIELD_DATA,
    data
});

export const createWorkflowAction = (data) => ({
    type: types.CREATE_WORKFLOW_ACTION,
    data
});

export const editWorkflowAction = (id, data) => ({
    type: types.EDIT_WORKFLOW_ACTION,
    id,
    data
});

export const deleteWorkflowAction = (name, id) => ({
    type: types.DELETE_WORKFLOW_ACTION,
    name,
    id
});

export const serviceCardData = (data) => ({
    type: types.SERVICE_CARD_DATA,
    data
});

export const createServiceCard = (data) => ({
    type: types.CREATE_SERVICE_CARD,
    data
});

export const editServiceCard = (data) => ({
    type: types.EDIT_SERVICE_CARD,
    data
});

export const reArrangeServiceCard = (data) => ({
    type: types.REARRANGE_SERVICE_CARD,
    data
});

export const deleteServiceCard = (title, id) => ({
    type: types.DELETE_SERVICE_CARD,
    title,
    id
});

export const categoryData = (data) => ({
    type: types.CATEGORY_DATA,
    data
})

export const createCategory = (data) => ({
    type: types.CREATE_CATEGORY,
    data
});

export const editCategory = (data) => ({
    type: types.EDIT_CATEGORY,
    data
});

export const deleteCategory = (title, id) => ({
    type: types.DELETE_CATEGORY,
    title,
    id
});

export const getAllMappedForms = () => {
    return customAxios.get(CONFIG.apiURL + '/Forms/Mappings').then(res => {
        let response = res['data'];
        return response;
    });
};

export const getAllForms = () => {
    return customAxios.get(CONFIG.apiURL + '/Forms').then(res => {
        let response = res['data'];
        return response;
    });
};

export const getIndividualForm = (id) => {
    return customAxios.get(CONFIG.apiURL + `/Forms/${id}`).then(res => {
        let response = res['data'];
        return response;
    });
};

export const createForm = (payload) => {
    return customAxios.post(CONFIG.apiURL + '/Forms/Create', payload).then(res => {
        let response = res['data'];
        return response;
    });
};

export const updateForm = (payload) => {
    return customAxios.put(CONFIG.apiURL + '/Forms/Update', payload).then(res => {
        let response = res['data'];
        return response;
    });
};

export const getAllServices = () => {
    return customAxios.get(CONFIG.apiURL + '/Departments/Services').then(res => {
        let response = res['data'];
        return response;
    });
};

export const formMapping = (payload) => {
    return customAxios.post(CONFIG.apiURL + '/Forms/Mapping', payload).then(res => {
        let response = res['data'];
        return response;
    });
};

export const uploadSingleDocument = (payload) => {
    return customAxios.post(CONFIG.documentURL + '/DocumentVault/Document/Upload', payload).then(res => {
        let response = res['data'];
        return response;
    });
};

export const uploadMultipleDocument = (payload) => {
    return customAxios.post(CONFIG.documentURL + '/DocumentVault/Document/multiUpload', payload).then(res => {
        let response = res['data'];
        return response;
    })
};

export const getDocumentMetaData = (userID, documentIds) => {
    return customAxios.get(CONFIG.documentURL + `/DocumentVault/Document/GetMetadata?userId=${userID}&documentIds=${documentIds}`).then(res => {
        let response = res['data'];
        return response;
    });
};

export const listAllUserContainers = () => {
    return customAxios.get(CONFIG.documentURL + '/DocumentVault/Document/ListAllContainers').then(res => {
        let response = res['data'];
        return response;
    });
};

export const listUserDocuments = (userID) => {
    return customAxios.get(CONFIG.documentURL + `/DocumentVault/Document/ListAll?userId=${userID}`).then(res => {
        let response = res['data'];
        return response;
    });
};

export const previewDocument = (userID, documentID) => {
    return customAxios.get(CONFIG.documentURL + `/DocumentVault/Document/Download?userId=${userID}&documentId=${documentID}`).then(res => {
        let response = res['data'];
        return response;
    });
};

export const removeDocument = (userID, documentID) => {
    return customAxios.delete(CONFIG.documentURL + `/DocumentVault/Document/Delete?userId=${userID}&documentId=${documentID}`).then(res => {
        let response = res['data'];
        return response;
    });
};

export const slackBOT = (payload) => {
    return axios.post('https://hooks.slack.com/services/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', JSON.stringify(payload), {
        withCredentials: false,
        transformRequest: [(data, headers) => {
          delete headers.post["Content-Type"]
          return data
        }]
      })
}